// extracted by mini-css-extract-plugin
export default {"tabPanel":"TabPanel_tabPanel__LmVgM","tabPanelGuide":"TabPanel_tabPanelGuide__vvk3i"};